import apiFetch from '@wordpress/api-fetch';
import { classifyHttpError, safeFetch } from './errors';

function decodeJwt( token: string ): { exp?: number } | null {
	try {
		const base64Payload = token.split( '.' )[ 1 ];
		const payload = atob( base64Payload );
		return JSON.parse( payload );
	} catch {
		return null;
	}
}

function isTokenExpired( token: string ): boolean {
	const payload = decodeJwt( token );
	if ( ! payload?.exp ) {
		return true;
	}
	return payload.exp * 1000 <= Date.now() + 60000;
}

async function fetchToken(): Promise< string > {
	const tokenPath = window.agentConfig?.tokenPath
		|| `${ window.agentConfig?.agentWPApiBase ?? '/uconnect/v1/agent/' }auth/token`;

	const data = await apiFetch< { token: string } >( {
		path: tokenPath,
		method: 'POST',
	} );

	return data.token;
}

export async function getValidToken(): Promise< string > {
	const currentToken = window.agentConfig?.jwtToken;

	if ( currentToken && ! isTokenExpired( currentToken ) ) {
		return currentToken;
	}

	const newToken = await fetchToken();
	window.agentConfig.jwtToken = newToken;
	return newToken;
}

export async function requestWithAuth< T >(
	url: string,
	options: RequestInit = {}
): Promise< T > {
	const token = await getValidToken();
	const response = await safeFetch( url, {
		...options,
		mode: 'cors',
		headers: {
			Authorization: `Bearer ${ token }`,
			...( options.headers ?? {} ),
		},
	} );

	if ( ! response.ok ) {
		throw await classifyHttpError( response );
	}

	if ( response.status === 204 ) {
		return undefined as T;
	}

	return response.json() as Promise< T >;
}
